import {NotificationData, notifications} from "@mantine/notifications";
import {CloseIcon} from "@mantine/core";
import classes from "./notifications.module.css"
import {IconCheck} from "@tabler/icons-react";
import {v4 as uuidv4} from "uuid"

export const showSuccessNotification = ({title, message, ...others}: NotificationData) => {
    const config: NotificationData = {
        position: "bottom-center",
        classNames: {
            root: classes.root,
            icon: classes.successIcon,
            title: classes.title,
            description: classes.description,
            body: classes.body,
            loader: classes.loader,
        },
        loading:false,
        icon: <IconCheck/>,
        title: title,
        message: message,
        autoClose: 5000,
        ...others,
    }
    if (config.id)
        notifications.update(config)
    else
        notifications.show(config)
}

export const showErrorNotification = ({title, message, ...others}: NotificationData) => {
    const config: NotificationData = {
        position: "bottom-center",
        classNames: {
            root: classes.root,
            icon: classes.errorIcon,
            title: classes.title,
            description: classes.description,
            body: classes.body,
            loader: classes.loader,
        },
        loading:false,
        icon: <CloseIcon/>,
        title: title,
        message: message,
        autoClose: 10000,
        ...others,
    }
    if (config.id)
        notifications.update(config)
    else
        notifications.show(config)
}

export const showToast = (message: string): void => {
    notifications.show({
        position: "bottom-center",
        message,
        autoClose: 4000,
    })
}

export const showRetryNotification = ({id, title, message, ...others}: NotificationData) => {
    const nid = id ?? uuidv4()
    const config: NotificationData = {
        id: nid,
        position: "bottom-center",
        classNames: {
            root: classes.root,
            icon: classes.warningIcon,
            title: classes.title,
            description: classes.description,
            body: classes.body,
            loader: classes.loader,
        },
        loading:true,
        autoClose:false,
        title: title,
        message: message,
        ...others,
    }
    if (id === undefined) {
        notifications.show(config)
    } else {
        notifications.update(config)
    }
    return nid
}